import React from 'react';
import "./Education.css";

export default function Education() {
  return (
    <div>
      <div className='d-flex flex-column'>
        <div className='education-one my-4 justify-content-between d-flex flex-row'>

          <div className='d-flex flex-column new-one'>
            <span className='university-name'>
              Universti Tunku Abdul Rahman{""}
            </span>
            <span className='university-degree'>
              Bachelor of Information Systems Engineering{""}
            </span>
          </div>{""}
          <div>
            <span className='year-passed-out'>2018-2021</span>
          </div>


        </div>
        <div className='education-one my-4 justify-content-between d-flex flex-row'>

          <div className='d-flex flex-column new-one'>
            <span className='university-name'>
              Universti Tunku Abdul Rahman{""}
            </span>
            <span className='university-degree'>
              Bachelor of Information Systems Engineering{""}
            </span>
          </div>{""}
          <div>
            <span className='year-passed-out'>2018-2021</span>
          </div>


        </div>
        <div className='education-one my-4 justify-content-between d-flex flex-row'>

          <div className='d-flex flex-column new-one'>
            <span className='university-name'>
              Universti Tunku Abdul Rahman{""}
            </span>
            <span className='university-degree'>
              Bachelor of Information Systems Engineering{""}
            </span>
          </div>{""}
          <div>
            <span className='year-passed-out'>2018-2021</span>
          </div>


        </div>
      </div>
    </div>
  );
}